<template>
  <v-container
    fluid
    class="found-leak v-card v-sheet space"
    fill-height
  >
    <v-layout
      align-space-around
      justify-space-around
      row
      wrap
    >
      <v-flex xs9>
        <v-layout
          align-space-around
          justify-space-around
          column
        >
          <v-flex>
            <v-select
              v-model="leakType"
              :items="leakTypes"
              item-text="displayName"
              item-value="key"
              :label="strings.leakType"
              accent
              :class="leakTypeClass"
              :error="leakTypeClass.missing"
            />
          </v-flex>
          <v-flex>
            <v-select
              v-model="equipmentUsed"
              :items="equipmentList"
              item-value="id"
              item-text="name"
              :menu-props="{ maxHeight: '400' }"
              :label="strings.equipmentUsed"
              multiple
              hint="List any equipment used"
              :class="equipmentUsedClass"
              :error="equipmentUsedClass.missing"
            />
          </v-flex>
          <v-flex>
            <v-select
              v-model="assetLeakType"
              :items="assetLeakTypes"
              item-value="key"
              item-text="displayName"
              :menu-props="{ maxHeight: '400' }"
              :label="strings.assetLeakType"
              hint="Visibility of the leak"
              :class="assetLeakTypeClass"
              :error="assetLeakTypeClass.missing"
            />
          </v-flex>
          <v-flex>
            <v-select
              v-model="priority"
              :items="priorities"
              item-value="value"
              item-text="label"
              :menu-props="{ maxHeight: '400' }"
              :label="strings.priority"
              hint="Priority"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="workOrder"
              outlined
              :rules="[rules.required, rules.counter]"
              counter
              maxlength="12"
              :label="strings.workOrder"
              :class="WorkOrderClass"
              :error="WorkOrderClass.missing"
            />
          </v-flex>
          <v-flex>
            <v-radio-group
              v-model="classification"
              value="black"
              row
              :hint="strings.classification"
              persistent-hint
              :class="radioGroupClass"
              :error="radioGroupClass.missing"
            >
              <div
                v-for="classifier in classifications"
                :key="classifier.label"
              >
                <v-radio
                  :label="classifier.label"
                  :value="classifier.value"
                  :color="radioButtonColour"
                />
              </div>
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs3>
        <v-layout
          align-center
          justify-center
          column
          fill-height
          wrap
        >
          <v-flex
            grow
            class="center"
          >
            <v-btn
              outline
              fab
              :color="mapMarkerButtonColour"
              :class="mapMarkerButtonClass"
              class="thick"
              @click="onGetLeakCoords"
            >
              <v-icon color="text">
                mdi-map-marker
              </v-icon>
            </v-btn>
          </v-flex>
          <v-flex v-if="leak.leakCoords">
            Lat: {{ leak.leakCoords.latitude.toFixed(displayDecimals) }}
          </v-flex>
          <v-flex v-if="leak.leakCoords">
            Lng: {{ leak.leakCoords.longitude.toFixed(displayDecimals) }}
          </v-flex>
          <v-flex
            grow
            class="center"
          >
            <v-btn
              fab
              small
              color="primary"
              @click="onDeleteLeak"
            >
              <v-icon color="text">
                mdi-delete
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <LocationDialog
      v-model="showLocationDialog"
      :poi-center="poiCoords"
      @leakMarkerSet="onLeakMarkerSet"
    />
  </v-container>
</template>

<script>
import { LeakTypes } from "../config/leak.js";
import { AssetLeakTypes } from "../config/assetLeakType.js";
import { DetectionMethods } from "../config/equipment.js";
import LocationDialog from "../components/LocationDialog";
import { mapGetters } from "vuex";
export default {
  name: "FoundLeak",
  components: {
    LocationDialog
  },
  props: [
    "leak",
    "poiCoords",
    "highlightMissingGPS",
    "highlightMissingClassification",
    "highlightMissingAssetLeakType",
    "highlightMissingEquipmentUsed",
    "highlightMissingLeakType",
    "highlightMissingWorkOrder",
    "hasPlastic"
  ],
  data() {
    return {
      showLocationDialog: false,
      displayDecimals: 5,
      localClassification: null,
      localAssetLeakType: null,
      localLeakType: null,
      localEquipmentUsed: [],
      localPriority: null,
      localWorkOrder: "",
      priorities: [
        {
          label: "1",
          value: 1
        },
        {
          label: "2",
          value: 2
        },
        {
          label: "3",
          value: 3
        },
        {
          label: "4",
          value: 4
        },
        {
          label: "5",
          value: 5
        }
      ],
      rules: {
        required: value => value.length > 0 || "Required",
        counter: value => value.length <= 20 || "Max 12 characters",
        notNull: value => !!value || "Required"
      }
    };
  },
  computed: {
    ...mapGetters("page", ["strings"]),
    ...mapGetters("settings", ["setting"]),
    classifications(){
      return [
        {
          label: this.strings.major,
          value: 1
        },
        {
          label: this.strings.minor,
          value: 2
        },
        {
          label: this.strings.customer,
          value: 3
        }
      ];
    },
    leakTypes() {
      return LeakTypes.sort(this.namedSort);
    },
    equipmentList() {
      var methods = DetectionMethods.sort(this.namedSort);

      if(this.setting.plasticEquipment && this.hasPlastic) {
        var arr = [];
        methods.forEach(m => {
          var exists = this.setting.plasticEquipmentList.find(l => l == m.id);
          if(exists != null && exists != undefined) {
            arr.push(m);
          }
        })

        methods = arr;
      }
      else {
        var arr = [];
        methods.forEach(m => {
          var exists = this.setting.equipmentList.find(l => l == m.id);
          if(exists != null && exists != undefined) {
            arr.push(m);
          }
        })

        methods = arr;
      }
      return methods;
    },
    assetLeakTypes() {
      return AssetLeakTypes.sort(this.namedSort);
    },
    mapMarkerButtonColour() {
      if (this.highlightMissingGPS && !this.leak.leakCoords) {
        return "warning";
      }
      return "primary";
    },
    mapMarkerButtonClass() {
      return {
        missing: this.highlightMissingGPS && !this.leak.leakCoords
      };
    },
    radioButtonColour() {
      if (this.highlightMissingClassification && !this.localClassification) {
        return "warning";
      }
      return "black";
    },
    radioGroupClass() {
      return {
        missing:
          this.highlightMissingClassification && !this.localClassification
      };
    },
    assetLeakTypeClass() {
      return {
        missing:
          this.highlightMissingAssetLeakType && this.localAssetLeakType == null
      };
    },
    priorityClass() {
      return {
        missing: this.highlightMissingAssetLeakType && this.lo == null
      };
    },
    leakTypeClass() {
      return {
        missing: this.highlightMissingLeakType && this.localLeakType == null
      };
    },
    WorkOrderClass() {
      return {
        missing: this.highlightMissingWorkOrder && this.localWorkOrder == ""
      };
    },
    equipmentUsedClass() {
      return {
        missing:
          this.highlightMissingEquipmentUsed && this.localEquipmentUsed == 0
      };
    },
    leakType: {
      get() {
        return this.leak.leakType != null ? Number(this.leak.leakType) : null;
      },
      set(value) {
        this.localLeakType = value;
        this.leak.leakType = value;
      }
    },
    equipmentUsed: {
      get() {
        return this.leak.equipmentUsed != null
          ? this.leak.equipmentUsed.map(x => Number(x))
          : null;
      },
      set(value) {
        this.localEquipmentUsed = value;
        this.leak.equipmentUsed = [...value];
      }
    },
    assetLeakType: {
      get() {
        return this.leak.assetLeakType != null
          ? Number(this.leak.assetLeakType)
          : null;
      },
      set(value) {
        this.localAssetLeakType = value;
        this.leak.assetLeakType = value;
      }
    },
    priority: {
      get() {
        if (this.localPriority) return this.localPriority;
        else return 5;
      },
      set(value) {
        this.localPriority = value;
        this.leak.priority = value;
      }
    },
    classification: {
      get() {
        if (this.localClassification) return this.localClassification;
        else return null;
      },
      set(value) {
        this.localClassification = value;
        this.leak.classification = value;
      }
    },
    workOrder: {
      get() {
        if (this.localWorkOrder) return this.localWorkOrder;
        else return "";
      },
      set(value) {
        this.localWorkOrder = value;
        this.leak.workOrder = value;
      }
    }
  },
  mounted() {
    if (this.leak) {
      if (this.leak.classification) {
        this.localClassification = this.leak.classification;
      }
      if (this.leak.assetLeakType) {
        this.localAssetLeakType = this.leak.assetLeakType;
      }
      if (this.leak.leakType) {
        this.localLeakType = this.leak.leakType;
      }
      if (this.leak.equipmentUsed) {
        this.localEquipmentUsed = this.leak.equipmentUsed;
      }
      if (this.leak.priority) {
        this.localPriority = this.leak.priority;
      }
      if (this.leak.workOrder) {
        this.localWorkOrder = this.leak.workOrder;
      }
    } else {
      this.leak.priority = 5;
    }
  },
  methods: {
    onGetLeakCoords() {
      this.showLocationDialog = !this.showLocationDialog;
    },
    onLeakMarkerSet(marker) {
      this.leak.leakCoords = {
        longitude: marker.longitude,
        latitude: marker.latitude
      };
    },
    onDeleteLeak() {
      this.$emit("delete");
    },
    namedSort(a, b) {
      let nameA = a.name.toUpperCase(); // ignore upper and lowercase
      let nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;
    }
  }
};
</script>

<style scoped>
.flex.grow.center {
  align-items: center;
  justify-content: center;
  display: flex;
}

.container.fluid.fill-height.found-leak {
  background-color: #00000020;
  padding: 0rem 0rem 0.75rem 0.75rem;
}
.found-leak.space {
  margin-top: 0.5rem;
}

.v-btn.v-btn--outline.thick {
  border: 4px solid;
}

.missing {
  animation: shake 2.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  animation-iteration-count: infinite;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
}

@keyframes shake {
  2%,
  18% {
    transform: translate3d(-1px, 0, 0);
  }

  4%,
  16% {
    transform: translate3d(2px, 0, 0);
  }

  6%,
  10%,
  14% {
    transform: translate3d(-4px, 0, 0);
  }

  4%,
  12% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>
